<h2 i18n>Insert croupier RFID card to continue</h2>
<div [ngClass]="animationClass"></div>
